import { useParams, Link } from 'react-router-dom'
import { useFinancialPlanStore } from '../store/financialPlanStore'
import { Settings, TrendingUp, DollarSign, Calendar } from 'lucide-react'

export function Optimizers() {
  const { clientId } = useParams()
  const { currentPlan } = useFinancialPlanStore()

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <div>
              <h1 className="text-2xl font-bold text-gray-900">Optimization Tools</h1>
              <p className="text-sm text-gray-600">
                {currentPlan?.clientName} • Strategic planning recommendations
              </p>
            </div>
            <Link to={`/dashboard/${clientId}`} className="btn-secondary text-sm">
              ← Back to Dashboard
            </Link>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <div className="grid md:grid-cols-2 gap-6">
          {/* Roth Conversion Optimizer */}
          <div className="card hover:shadow-lg transition-shadow cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-3 bg-blue-100 rounded-lg">
                <TrendingUp className="h-6 w-6 text-blue-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  Roth Conversion Strategy
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Optimize Roth conversions to minimize lifetime taxes and maximize tax-free growth.
                  Factors in SECURE Act 2.0 and inherited IRA rules.
                </p>
                <button className="btn-primary text-sm" disabled>
                  Coming Soon
                </button>
              </div>
            </div>
          </div>

          {/* Withdrawal Strategy */}
          <div className="card hover:shadow-lg transition-shadow cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-3 bg-green-100 rounded-lg">
                <DollarSign className="h-6 w-6 text-green-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  Withdrawal Strategy
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Optimize the order and mix of qualified vs non-qualified withdrawals to minimize taxes.
                </p>
                <button className="btn-primary text-sm" disabled>
                  Coming Soon
                </button>
              </div>
            </div>
          </div>

          {/* Social Security Timing */}
          <div className="card hover:shadow-lg transition-shadow cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-3 bg-purple-100 rounded-lg">
                <Calendar className="h-6 w-6 text-purple-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  Social Security Timing
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Analyze optimal claiming age (62, FRA, or 70) with breakeven analysis and spousal strategies.
                </p>
                <button className="btn-primary text-sm" disabled>
                  Coming Soon
                </button>
              </div>
            </div>
          </div>

          {/* Cash Reallocation */}
          <div className="card hover:shadow-lg transition-shadow cursor-pointer">
            <div className="flex items-start space-x-4">
              <div className="p-3 bg-orange-100 rounded-lg">
                <Settings className="h-6 w-6 text-orange-600" />
              </div>
              <div className="flex-1">
                <h3 className="text-lg font-bold text-gray-900 mb-2">
                  Cash Reallocation
                </h3>
                <p className="text-sm text-gray-600 mb-4">
                  Identify low-yielding cash and recommend optimal emergency fund amounts and investment allocation.
                </p>
                <button className="btn-primary text-sm" disabled>
                  Coming Soon
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 p-6 bg-blue-50 border border-blue-200 rounded-lg">
          <h3 className="text-lg font-bold text-blue-900 mb-2">
            🚧 These optimizers are coming soon!
          </h3>
          <p className="text-sm text-blue-800">
            We're actively building these advanced planning tools. Each optimizer will provide
            actionable recommendations backed by detailed analysis and tax calculations.
          </p>
        </div>
      </div>
    </div>
  )
}
